  import superagent from 'superagent';
import * as c from '../constants/actionTypes';
import * as config from '../config/config';
import calculatePrice from '../util/calculatePrice';

export function RegisterNewUser_Request() {
  return {
    type: c.REGISTER_STUDENT_REQUEST,
    loading: true
  }
}
export function RegisterNewUser_Success(body) {
  return {
    type: c.REGISTER_STUDENT_SUCCESS,
    body: body,
    loading: false
  }
}

export function RegisterNewUser_Failure(error) {
  return {
    type: c.REGISTER_STUDENT_FAILURE,
    error: error,
    loading: false
  }
}

export function CheckExistingUser_Request(res) {
  return {
    type: c.CHECK_EXISTING_USER,
    res: res,
    loading: true
  }
}

export function LoginUser_Request() {
  return {
    type: c.LOGIN_STUDENT_REQUEST,
    loading: true
  }
}

export function LoginUser_Success(body) {
  return {
    type: c.LOGIN_STUDENT_SUCCESS,
    body: body,
    loading: false
  }
}

export function LoginUser_Failure(error) {
  return {
    type: c.LOGIN_STUDENT_FAILURE,
    error: error,
    loading: false
  }
}

export function UserSession_Request() {
  return {
    type: c.USER_SESSION_REQUEST,
    loading: true
  }
}

export function UserSession_Success(body) {
  return {
    type: c.USER_SESSION_SUCCESS,
    body: body,
    loading: false
  }
}

export function AnonUserSession_Fetched() {
  return {
    type: c.USER_SESSION_ANON_FETCHED,
    loading: false
  }
}

export function UserSession_Failure(error) {
  return {
    type: c.USER_SESSION_FAILURE,
    error: error,
    loading: false
  }
}

export function Logout_Success() {
  return {
    type: c.LOGOUT_SUCCESS,
    loggedin: false,
    loading: false
  }
}


export function validateEmail_request(email){
  return {
    type: c.VALIDATE_EMAIL,
    loading: false,
    email: email
  }
}

export function invalidateEmail(){
  return {
    type: c.INVALIDATE_EMAIL,
    loading: false
  }
}

export function updateUserEmail(body) {
  return {
    type: c.UPDATE_USER_EMAIL,
    email: body,
    loading: false
  }
}

export function validateEmail(user){
  return function(dispatch) {
    dispatch(validateEmail_request(user))
    var user_ob = {
      user: user
    }
  }
}

export function storeEmail(email, docId) {
  return function(dispatch) {
    superagent
    .post(config.BASE + 'api/paper/user')
    .withCredentials()
    .set('Content-Type', 'application/json')
    .send({'email': email, 'doc_id': docId})
    .end((err, res) => {
      if(err) {
        alert("An error occured, please contact us at info@editmypaper.ca");
      } else {
        // all good.
      }
    })
  }
}

export function getUserSession(cb){
  return function(dispatch) {
    console.log("about to check user session user, ");
    dispatch(UserSession_Request())
    superagent
    .get(config.BASE + 'api/user')
    .set('Content-Type', 'application/json')
    .withCredentials()
    .end((err, res) => {
      if (err) {
        console.log("Error   ---------> " + JSON.stringify(err))
        dispatch(UserSession_Failure(err))
        if(cb) cb(false);
      } else {
        console.log("Success user: ", res.body.user);
        if(res.body.user){
          if(res.body.user.loggedin){
            dispatch(UserSession_Success(res.body))
            if(cb) cb(res.body);
            if(window.woopra !== 'undefined') {
              window.woopra.identify({
                email: res.body.user.email,
                name: res.body.user.first_name + " " + res.body.user.last_name,
                //company: "<<YOUR CUSTOMER COMPANY HERE>>"
              });
            }
          }
        } else {
          dispatch(AnonUserSession_Fetched());
          if(cb) cb(false);
        }
        window.woopra.track();
      }
    })
  }
}

export function CheckExistingUser(email, cb){
  return function(dispatch) {
    console.log('checking your email');
    dispatch(CheckExistingUser_Request())
    superagent
    .get(config.BASE + 'api/users/'+email)
    .set('Content-Type', 'application/json')
    .send()
    .end((err, res) => {
      if(err)
        {
          cb(false);
        }
        else{
          cb(true);
        }
    });
  }
}
export function LoginUser(user, cb){
  return function(dispatch) {
    console.log("about to login user, ", user);
    dispatch(LoginUser_Request())
    superagent
    .post(config.BASE + 'api/login')
    .set('Content-Type', 'application/json')
    .withCredentials()
    .send(user)
    .end((err, res) => {
      if (err) {
        console.log("Error   ---------> " + JSON.stringify(err))
        dispatch(LoginUser_Failure(err))
      } else {
        console.log("Success user: ", res.body.user);
        if(res.body.user){
          if(res.body.user.loggedin){
            dispatch(LoginUser_Success(res.body))
          }
        }
        cb(res.body)
      }
    })
  }
}

export function logout(cb){
  return function(dispatch) {

    superagent
    .get(config.BASE + 'api/logout')
    .withCredentials()
    .set('Content-Type', 'application/json')
    .end((err, res) => {
      if (err) {
        console.log("Error   ---------> " + JSON.stringify(err))
        dispatch(RegisterNewUser_Failure(err))
      } else {
        dispatch(Logout_Success(res.body))
        if(cb) {
          cb();
        }
      }
    })
  }
}

export function RegisterNewEditor(user, paper){
  return function(dispatch) {
    dispatch(RegisterNewUser_Request())
    var send_data = {
      user: user
    }
    superagent
    .post(config.BASE + 'api/editor/register')
    .set('Content-Type', 'application/json')
    .send(send_data)
    .withCredentials()
    .end((err, res) => {
      if (err) {
        console.log("Error   ---------> " + JSON.stringify(err))
        dispatch(RegisterNewUser_Failure(err))
      } else {
        alert("Your Registration was successful! You will receive an email with your password");
        dispatch(RegisterNewUser_Success(res.body))
      }
    })
  }
}


export function RegisterNewUser(user, paper){
  return function(dispatch) {
    dispatch(RegisterNewUser_Request())
    var send_data = {
      user: user,
      paper: paper
    }
    superagent
    .post(config.BASE + 'api/student/register')
    .set('Content-Type', 'application/json')
    .send(send_data)
    .withCredentials()
    .end((err, res) => {
      if (err) {
        console.log("Error   ---------> " + JSON.stringify(err))
        dispatch(RegisterNewUser_Failure(err))
      } else {
        alert("Your Registration was successful! You will receive an email with your password");
        dispatch(RegisterNewUser_Success(res.body))
      }
    })
  }
}

export function ChangePassword(existingPass, newPass, verifyPass)
{
  var send_data = {
      currentPassword: existingPass,
      newPassword: newPass,
      verifyPassword: verifyPass
  }
  superagent.post(config.BASE + 'api/users/changepassword')
  .set('Content-Type', 'application/json')
  .send(send_data)
  .withCredentials()
  .end((err, res) => {
    console.log("got response for updating a password with ");
    console.log(res);
    if(err) {
      alert("Failed changing password");
      return false;
    } else {
      alert("Password successfully changed");
      return true;
    }
  })
}

export function updateUserProfile(data) {
  superagent.post(config.BASE + 'api/users/updateprofile')
  .set('Content-Type', 'application/json')
  .send(data)
  .withCredentials()
  .end((err, res) => {
    console.log("got response for updating user profile with ");
    console.log(res);
    if(err) {
      alert("Failed updating profile");
      return false;
    } else {
      alert("Profile updated successfully");
      return true;
    }
  })
}

export function resetPassword(email) {
  var data = {username: email};
  data.fronthost = window.location.protocol+'//'+window.location.hostname;
  if(window.location.port && window.location.port != 80 && window.location.port != 443) {
    data.fronthost += ':'+window.location.port;
  }
  superagent.post(config.BASE + 'api/auth/forgot')
  .set('Content-Type', 'application/json')
  .send(data)
  .withCredentials()
  .end((err, res) => {
    if(err) {
      alert("are you sure you signed up with this email?");
      return false;
    } else {
      alert("Look in your inbox for instructions");
      return true;
    }
  })
}


export function validateTokenAndResetPassword(token, cb) {
  superagent.post(config.BASE + 'api/auth/validateAndSend')
  .set('Content-Type', 'application/json')
  .send({token: token})
  .withCredentials()
  .end((err, res) => {
    if(err) {
      cb(false);
    } else {
      cb(true);
    }
  })
}


// WEBPACK FOOTER //
// ./src/actions/user.js